@if ((formGroup.controls[field.property]?.value || !summary)) {
  <label for="{{(!summary ? field.property : '')}}"
    [formGroup]="formGroup"
    class="wb-{{layout}} wb-{{(opened ? 'opened' : 'closed')}} wb-{{field.type}} wb-custom-{{this.cleanLabel}}"
    >
    @if (
      (
      field.type !== 'collapse' &&
      field.type !== 'hidden' &&
      field.type !== 'checkbox' &&
      field.type !== 'couponCode' &&
      field.type !== 'hiddenInput' &&
      field.type !== 'hiddenInputAddress' &&
      field.type !== 'number' &&
      (field.type !== 'sortable-address'|| returnTrip) &&
      (
      field.type !== 'dateTime' ||
      (field.type === 'dateTime' && summary)
      )
      ) && !hiddenFieldTitles
      ) {
      <span
        class="wb-summary-name"
        >
        {{
        (field.label
        ? field.label
        : (summary ? field.placeholder : '')
        ) | translate | ucFirst
        }}
        @if (field.required && !summary) {
          <span
            class="wb-field-wrapper-required"
            >
            *
          </span>
        }
        @if (field.helpText && !summary) {
          <span
            class="wb-help"
            (click)="toggleHelpModal(field.label, field.helpText)"
            >
            <app-svg-icon [icon]="faInfoCircle"></app-svg-icon>
          </span>
        }
      </span>
    }
    @if (field.type === 'collapse' && field.dynamic) {
      <span class="wb-summary-name wb-options-pane"
        id="collapse-{{index}}" (click)="toggleSection('collapse-'+index)">
        {{ field.label | translate | ucFirst }}
        @if (!opened) {
          <app-svg-icon [icon]="faChevronDown"></app-svg-icon>
        }
        @if (opened) {
          <app-svg-icon [icon]="faChevronUp"></app-svg-icon>
        }
      </span>
    }
    @if (!summary) {
      @if (field.type === 'text' || field.type === 'email') {
        <input [formControlName]="field.property"
          (keyup)="hasErrors=false" type="{{field.type}}" id="{{field.property}}"
          [attr.list]="field.property === 'firstName' && recentPassengers.length ? passengerListId : null"
          [attr.autocomplete]="field.property === 'firstName' && recentPassengers.length ? 'off' : null"
          (input)="field.property === 'firstName' && applyRecentPassenger($event)"
          [ngClass]="hasErrors ? 'error' : ''" placeholder="{{field.placeholder | translate | ucFirst}}">
          @if (field.property === 'firstName' && recentPassengers.length) {
            <datalist [id]="passengerListId">
              @for (p of recentPassengers; track p) {
                <option [value]="passengerLabel(p)"></option>
              }
            </datalist>
          }
          <app-field-error [config]="field" (validityChanged)="validityChanged($event)"></app-field-error>
        }
        @if (field.type === 'checkbox') {
          <app-checkbox-field [config]="field"
            [control]="formGroup"
          (openHelpModal)="toggleHelpModal($event.helpTitleTag, $event.helpTextTag, $event.type, $event.meta)"></app-checkbox-field>
        }
        @if (field.type === 'select') {
          <app-select-field [config]="field"
          [control]="formGroup"></app-select-field>
        }
        @if (field.type === 'phone') {
          <app-phone-field [config]="field"
          [control]="formGroup"></app-phone-field>
        }
        @if (field.type === 'flightNumber') {
          <app-flight-number-field [config]="field"
          [control]="formGroup"></app-flight-number-field>
        }
        @if (field.type === 'couponCode' && (this.formGroup.controls && this.formGroup.controls['product'] &&
          this.formGroup.controls['product'].value && this.formGroup.controls['product'].value.price.total)) {
          <app-coupon-code-field [config]="field"
          [control]="formGroup"></app-coupon-code-field>
        }
        @if (field.type === 'paymentMethod') {
          <app-payment-method-field [config]="field"
          [control]="formGroup"></app-payment-method-field>
        }
        @if (field.type === 'hidden') {
          <input [formControlName]="field.property" value="{{field.default}}" type="{{field.type}}"
            id="{{field.property}}"
            [ngClass]="hasErrors ? 'error' : ''" placeholder="{{field.placeholder | translate | ucFirst}}">
          }
          @if (field.type === 'textArea') {
            <textarea [formControlName]="field.property" id="{{''+field.property}}"
            placeholder="{{field.placeholder | translate | ucFirst}}"></textarea>
          }
          @if (field.type === 'dateTime') {
            <app-date-time-field [config]="field"
              [control]="formGroup"
              [minimumOrderTime]="minimumOrderTime"
              [orderTimesHandler]="(mainConfig && mainConfig.orderTimesHandler ? mainConfig.orderTimesHandler : 'availability')"
              [orderMode]="orderMode"
              [airportDates]="(mainConfig ? mainConfig.airportDates : '')"
              [configRequestedDestinationDateOffset]="(mainConfig && mainConfig.requestedDestinationDateOffset ? mainConfig.requestedDestinationDateOffset : '')"
              [airportDeparture]="airportDeparture"
              [airportDestination]="airportDestination"
            (doToggleHelpText)="toggleHelpModal($event.helpTitleTag, $event.helpTextTag)"></app-date-time-field>
          }
          @if (field.type === 'address') {
            <app-address-field [config]="field" [form]="formGroup"
              (openHelpModal)="toggleHelpModal($event.helpTitleTag, $event.helpTextTag, $event.type, $event.meta)"
            (checkWorkArea)="checkWorkAreaEmit($event)"></app-address-field>
          }
          @if (field.type === 'sortable-address') {
            <app-sortable-address-field [departureConfig]="part.fields[0]"
              [destinationConfig]="part.fields[2]"
              [bookingHourlyDestination]="(mainConfig && mainConfig.bookingHourlyDestination ? mainConfig.bookingHourlyDestination : false)"
              [allowStopOversRoute]="(mainConfig ? !!mainConfig.allowStopOversRoute : false)"
              [allowStopOversHourly]="(mainConfig ? !!mainConfig.allowStopOversHourly : false)"
              [activeTab]="activeTab"
              (checkWorkArea)="checkWorkAreaEmit($event)"
              (openHelpModal)="toggleHelpModal($event.helpTitleTag, $event.helpTextTag, $event.type, $event.meta)"
            [form]="formGroup"></app-sortable-address-field>
          }
          @if (field.type === 'number') {
            <app-number-field [className]="(index % 2 === 0 ? 'even' : 'odd')" [config]="field" [control]="formGroup"
            (openHelpModal)="toggleHelpModal($event.helpTitleTag, $event.helpTextTag, $event.type, $event.meta)"></app-number-field>
          }
        }
        @if (summary) {
          <span class="wb-summary-value">
            <app-field-value [field]="field"
              [formGroup]="formGroup"
              [orderMode]="orderMode"
              [summary]="summary"
              [form]="form"
              [airportDeparture]="airportDeparture"
            [airportDestination]="airportDestination"></app-field-value>
          </span>
        }
        @if (field.type === 'collapse') {
          @for (field of field.fields; track field; let i = $index) {
            <app-field-wrapper [className]="'wb-field wb-'+field.type+' '+field.cssclass"
              [minimumOrderTime]="minimumOrderTime"
              [index]="i"
              [field]="field"
              [formGroup]="formGroup"
              [summary]="summary"
            (openHelpModal)="openHelpModal.emit($event)"></app-field-wrapper>
          }
        }
      </label>
    }
